"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TransportType;
(function (TransportType) {
    TransportType["plane"] = "plane";
    TransportType["bus"] = "bus";
    TransportType["boat"] = "boat";
    TransportType["car"] = "car";
    TransportType["fossilFueledCar"] = "fossilFueledCar";
    TransportType["electricVehicle"] = "electricVehicle";
    TransportType["hybridCar"] = "hybridCar";
    TransportType["carSharing"] = "carSharing";
    TransportType["motorbike"] = "motorbike";
    TransportType["shortDistanceBus"] = "shortDistanceBus";
    TransportType["longDistanceBus"] = "longDistanceBus";
    TransportType["train"] = "train";
    TransportType["shortHaulFlight"] = "shortHaulFlight";
    TransportType["mediumHaulFlight"] = "mediumHaulFlight";
    TransportType["longHaulFlight"] = "longHaulFlight";
})(TransportType = exports.TransportType || (exports.TransportType = {}));
